import Image from '@tiptap/extension-image';

export const RichImage = Image.extend({
    addOptions() {
        return {
            ...this.parent?.(),
            allowBase64: true,
        };
    },
    addAttributes() {
        return {
            ...this.parent?.(),
            width: {
                default: null,
                parseHTML: (element) => element.getAttribute('width'),
                renderHTML: (attributes) => (attributes['width'] ? { width: attributes['width'] } : {}),
            },
            height: {
                default: null,
                parseHTML: (element) => element.getAttribute('height'),
                renderHTML: (attributes) => (attributes['height'] ? { height: attributes['height'] } : {}),
            },
            style: {
                default: null,
                parseHTML: (element) => element.getAttribute('style'),
                renderHTML: (attributes) => (attributes['style'] ? { style: attributes['style'] } : {}),
            },
        };
    },
    parseHTML() {
        const rules = this.parent?.() ?? [];
        return [{ tag: 'figure.image > img[src]' }, ...rules];
    },
});
